import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
	ROUTE_PREFIX_EDIT_OFFER,
	ROUTE_PREFIX_EDIT_OFFER_MOBILE,
	ROUTE_PREFIX_CREATE_OFFER_MOBILE,
	ROUTE_PREFIX_CREATE_OFFER
} from "../shared/constants";
import Loading from "../../shared/Loading/Loading";
import { useNewOffer } from "../context/new-offer";
import { editOffer } from "../actions";
import { isMobile } from "../../../js/components/searchform/utils/common";

const RedirectOffer = ({ history, editOffer }) => {
	const { programsFidelity, offersData, selectOfferToEdit } = useNewOffer();
	const [acronymStorage, setAcronymStorage] = useState(
		localStorage.getItem("FidelityAcronym") || ""
	);
	const [createOffer, setCreateOffer] = useState();

	const routeEdit = isMobile() ? ROUTE_PREFIX_EDIT_OFFER_MOBILE : ROUTE_PREFIX_EDIT_OFFER;
	const routeCreate = isMobile() ? ROUTE_PREFIX_CREATE_OFFER_MOBILE : ROUTE_PREFIX_CREATE_OFFER;

	useEffect(() => {
		const createOfferJSON = localStorage.getItem("CreateOffer");
		localStorage.removeItem("FidelityAcronym");
		if (createOfferJSON) {
			localStorage.removeItem("CreateOffer");
			let offer = JSON.parse(createOfferJSON);
			
			setCreateOffer({
				...offer,
				maxMilesAmount: offer.fidelity?.maxMilesAmount,
				minMilesAmount: offer.fidelity?.minMilesAmount,
			});
			setAcronymStorage(offer.fidelity.label || offer.fidelity.airlineName);
		}
	}, []);
	if (offersData.isDone && programsFidelity.isDone) {
		let found = null;
		let newValues = {};

		if (offersData.data.offers && offersData.data.offers.length) {
			found = offersData.data.offers.find(
				offer =>
					offer.fidelity.airlineAcronym.toLowerCase() == acronymStorage.toLowerCase() &&
					offer.status > 0
			);
		}

		if (createOffer) {
			newValues = {
				newQuant: createOffer.quantMiles,
				newPrice: createOffer.price,
				quickSale: createOffer.quickSale,
				showModalQuickSaleProblem: createOffer.showModalQuickSaleProblem,
				forwardPayment: createOffer.forwardPayment,
				showModalForwardPaymentProblem: createOffer.showModalForwardPaymentProblem,
				workingDays: createOffer.workingDays,
				paymentDeadline: createOffer.paymentDeadline,
				paymentScheduleType: createOffer.paymentScheduleType
			};
		}

		if (found) {
			selectOfferToEdit({ ...found, ...newValues });
			history.push(routeEdit);
		} else if (programsFidelity.data.length) {
			found = programsFidelity.data.find(
				program => (program.acronym.toLowerCase() == acronymStorage.toLowerCase()) || (createOffer && (program.id == createOffer.fidelityId))
			);
			if (found) {
				selectOfferToEdit({ quant: createOffer.quantMiles, price: createOffer.price, fidelity: found, ...newValues });
			}
			history.push(routeCreate);
		}
	}

	return <Loading />;
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => {
	return {
		editOffer: offer => dispatch(editOffer(offer))
	};
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(RedirectOffer)
);
